// extracted by mini-css-extract-plugin
export default {"sound":"Sound_sound__Aw9EI","appear":"Sound_appear__gpjQz"};